<template>
    <vs-popup button-close-hidden :title="`Log # ${reference}`" :active.sync="$store.state.log_visibility" style="z-index:99990;">
        <div class="vx-col" v-if="data && data.length > 0">
            <vs-alert class="mb-3" active="true" v-for="(log, index) in data" :key="index">
                <div class="vx-col w-full">
                    <div>{{log.name}} ({{log.username}}) - {{log.action}}</div>
                </div>
                <div class="vx-col w-full">
                    <div class="small">{{renderDateTimeFormatByTimezone(log.created_at)}}</div>
                </div>
            </vs-alert>
        </div>
        <div class="vx-col text-center" v-else>
            <i>--- No log found ---</i>
        </div>
        <vs-divider class="mb-base" />
        <vs-button type="flat" @click="closePopupDialog()" class="mt-5 mr-2 float-right">{{$t('action.close').toUpperCase()}}</vs-button>
    </vs-popup>
</template>

<script>

import Global from '@/helper/global'

export default {
    name: 'show-log-popup',
    props: ['data', 'reference'],
    data () {
        return {

        }
    },
    methods:{
        closePopupDialog(){
            this.$emit('close')

            this.$store.commit({
                type: 'SET_POPUP_LOG_VISIBILITY',
                visibility: false
            })
        },
        renderDateTimeFormatByTimezone(datetime){
            return Global.renderDateTimeByTimezone(datetime)
        },
    }
}
</script>
